import { render, staticRenderFns } from "./TableRecord.vue?vue&type=template&id=7ef494e4&v-slot%3A%5B%60item%60%5D=%7B%20item%20%7D&"
import script from "./TableRecord.vue?vue&type=script&lang=ts&"
export * from "./TableRecord.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
